// TODO
/* export enum UserType {
  ArcaneAI = 'ArcaneAI',
  User = 'User'
} */

import { SCOPED_MESSAGE } from '~/constants/conversationModels';

export const mapDtoToMessage = (receivedMessage) => {
  console.log('received Message from chatbot =>', receivedMessage);
  return {
    text: receivedMessage.data.text || 'Something went wrong. No message from chatbot was found in response',
    type: 'message',
    isUser: false,
    references: receivedMessage.data.references,
  };
};

export const encodeToBase64 = (data) => {
  // First, convert text to a byte array using TextEncoder
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(data);

  // Convert the byte array to a binary string
  const binaryString = new Uint8Array(utf8Bytes).reduce((acc, byte) => acc + String.fromCharCode(byte), '');

  // Now encode this binary string to base64
  const base64Encoded = btoa(binaryString);

  return base64Encoded;
};

export const reassembleMessage = (message) => {
  const chunks = message.chunks || [];
  if (chunks.length === 1) {
    return chunks[0].chunk;
  }
  const orderedChunks = chunks
    .sort((msg1, msg2) => msg1.sequenceNr - msg2.sequenceNr) // Sort the sequence numbers
    .map((msg) => msg.chunk); // Map to the actual chunks

  // Concatenate the ordered chunks
  const finalMessage = orderedChunks.join('');
  return finalMessage;
};

export const decodeFromBase64 = (data) => {
  const bytes = new Uint8Array(
    atob(data)
      .split('')
      .map((char) => char.charCodeAt(0)),
  );

  // Decode the bytes as UTF-8 text
  const decodedText = new TextDecoder('utf-8').decode(bytes);

  return decodedText;
};

// this function will be called when we retrieve a conversation by id from db
export const groupMessagesByScopedCollection = (messages) => {
  const processedMessages = [];
  messages.forEach((message, index) => {
    if (index === 0) {
      // Always add the first message
      processedMessages.push(message);
    } else {
      // Check if current message has a collectionId and it's different from the previous one
      const prevMessage = messages[index - 1];
      if (
        (message.collection && !prevMessage.collection) ||
        (message.collection &&
          prevMessage.collection &&
          message.collection.collectionId !== prevMessage.collection.collectionId) ||
        (!message.collection && prevMessage.collection)
      ) {
        // Insert scoped message
        processedMessages.push({ ...SCOPED_MESSAGE, collection: message.collection });
      }
      // Add the current message
      processedMessages.push(message);
    }
  });
  return processedMessages;
};


export const extractReferencesFromCitations = (message) => {
  const citationRegex = /\[([^\]]+?)-(\d+),\s*p\.(\d+)\]/g;
  const citations = [];
  let match;
  while ((match = citationRegex.exec(message)) !== null) {
    citations.push({
      id: match[1],
      page: parseInt(match[2]),
      snippetIndex: 1,
    });
  }
  
  // Filter out duplicate document IDs
  const uniqueCitations = citations.reduce((acc, citation) => {
    if (!acc.find(existing => existing.documentId === citation.id)) {
      acc.push({documentId: citation.id});
    }
    return acc;
  }, []);
  
  return uniqueCitations;
};

export const processCitedReferences = (messageText, blockData) => {
  if (!blockData || blockData.length === 0) return blockData;
  
  const documentListBlock = blockData.find(block => block.type === 'documentList');
  if (!documentListBlock) return blockData;
  
  const citedRefs = extractReferencesFromCitations(messageText || '');
  const citedReferences = citedRefs.map(citedRef => 
    (documentListBlock.references || []).find(ref => ref.externalId === citedRef.documentId)
  );
  
  return [{ ...documentListBlock, citedReferences }];
};
